import { ADVISOR_AGREEMENT_FRAGMENT } from '@src/gql/fragments/AdvisorAgreementFragment'
import { gql } from '@src/lib/gql'

export const ADVISOR_AGREEMENTS = gql`
  query AdvisorAgreements($role: String, $statusKeys: [String], $pageSize: Int, $page: Int) {
    advisorAgreements(role: $role, statusKeys: $statusKeys, pageSize: $pageSize, page: $page) {
      items {
        ...AdvisorAgreementFragment
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageCount
      }
    }
  }
  ${ADVISOR_AGREEMENT_FRAGMENT}
`
